import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import About from "../pages/About";
import SingleBlog from "../pages/SingleBlog";
import Blogs from "../pages/Blogs";
import Contact from "../pages/Contact";
import Gallery from "../pages/Gallery";
import Gallery2 from "../pages/Gallery2";
import Menu from "../pages/Menu";
import News from "../pages/News";
import ProAdvantage from "../pages/ProAdvantage";
import Shipping from "../pages/Shipping";
import Testimonial from "../pages/Testimonial";
import RequestDemo from "../pages/RequestDemo";
import Gal from "../pages/Gal";
import Home from "../pages/Home";
import Events from "../pages/Events";
import OurTeam from "../pages/OurTeam";
import { useMediaQuery } from "@mui/material";
import InsuranceInquiry from "../pages/InsuranceInquiry";
import HsCodePage from "../pages/hs-code";
import TariffsAndRulesPage from "../pages/TarrifRules";
import IICSInquiry from "../pages/IICSInquiry";

const Navigation = () => {
  const isMedium = useMediaQuery("(max-width:950px)");
  const isSmall = useMediaQuery("(max-width:767px)");
  return (
    <Router scrollBehavior="auto">
      <img
        src={require("../assets/images/home/wechat.png")}
        alt=""
        style={{
          position: "fixed",
          bottom: "17.5%",
          right: 50,
          zIndex: 9999999,
          cursor: "pointer",
          height: isSmall ? "30px" : isMedium ? "37.5px" : "40px",
          width: isSmall ? "125px" : isMedium ? "150x" : "175px",
        }}
        onClick={() =>
          window.open("https://u.wechat.com/kBQdwyjcDK8YiApn89whXXo", "_blank")
        }
      />
      <img
        src={require("../assets/images/home/whatsapp.png")}
        alt=""
        style={{
          cursor: "pointer",
          position: "fixed",
          bottom: "10%",
          right: 50,
          zIndex: 9999999,
          height: isSmall ? "30px" : isMedium ? "37.5px" : "40px",
          width: isSmall ? "125px" : isMedium ? "150x" : "175px",
        }}
        onClick={() =>
          window.open(
            "https://api.whatsapp.com/send/?phone=14372147577&text=Hello%2C+I+saw+the+network+website.+I+have+a+few+questions+about+it%2C+are+you+available+to+chat%3F&type=phone_number&app_absent=0",
            "_blank"
          )
        }
      />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/test" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/news/:id" element={<SingleBlog />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/insurance-inquiry" element={<InsuranceInquiry />} />
        <Route path="/iics-inquiry" element={<IICSInquiry />} />
        <Route path="/gallery" element={<Gal />} />
        <Route path="/conference-gallery/:id" element={<Gallery />} />
        <Route path="/all-gallery/:conferenceId/:id" element={<Gallery2 />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/pro-advantage" element={<ProAdvantage />} />
        <Route path="/blog/:slug" element={<Shipping />} />
        <Route path="/testimonial" element={<Testimonial />} />
        <Route path="/news" element={<News />} />
        <Route path="/request-demo" element={<RequestDemo />} />
        <Route path="/events" element={<Events />} />
        <Route path="/team" element={<OurTeam />} />
        <Route path="/hs-code" element={<HsCodePage />} />
        <Route path="/tarrif-rules" element={<TariffsAndRulesPage />} />
      </Routes>
    </Router>
  );
};

export default Navigation;
